var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsChats({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 73,
    viewBox: "0 0 65 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.81458 51.3928C-3.8543 37.5842 -1.53177 17.4134 13.6979 6.74947C28.5868 -3.67585 48.406 0.639049 58.1852 14.6053C69.527 30.803 63.356 50.1081 50.3544 59.2119C46.0555 62.222 40.476 64.4076 35.0681 64.8296C33.1613 64.9518 31.6115 65.1374 30.5005 66.6192L26.3084 71.9019C25.2658 73.2582 23.3247 73.0524 22.7253 71.3595L20.3639 64.2492C20.0824 63.2334 19.4233 62.4037 18.526 62.0148C13.3674 59.4456 8.9029 55.8034 5.81458 51.3928ZM28.6198 35.4244C29.925 37.2884 32.4669 37.7387 34.3464 36.4618C36.2075 35.1586 36.6355 32.5897 35.3488 30.7522C34.0436 28.8882 31.5016 28.4379 29.6405 29.741C27.7873 30.9996 27.3331 33.5869 28.6198 35.4244ZM40.7224 26.9895C42.0091 28.827 44.5694 29.3035 46.4305 28.0004C48.2917 26.6972 48.7196 24.1283 47.4329 22.2908C46.1277 20.4268 43.5858 19.9765 41.7246 21.2796C39.8635 22.5828 39.4173 25.1255 40.7224 26.9895ZM22.2623 44.9232C20.4274 46.208 17.8408 45.7498 16.5542 43.9123C15.249 42.0483 15.6953 39.5056 17.5564 38.2024C19.4175 36.8993 21.9595 37.3496 23.2647 39.2136C24.5513 41.0511 24.105 43.5938 22.2623 44.9232Z",
    fill: "url(#paint0_linear_4264_4099)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4264_4099",
    x1: -27.2489,
    y1: 35.4207,
    x2: 30.0202,
    y2: 117.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsChats);
export default __webpack_public_path__ + "static/media/stats-chats.024b1683217b391d8422fd16388a8c0c.svg";
export { ForwardRef as ReactComponent };